import axios, { AxiosHeaders, AxiosError } from "axios";
import { showMessage } from "@eweadn-qiankun/shared-components";
import {
  createUnauthorizedError,
  getApiErrorMessage,
  isUnauthorizedError,
} from "@eweadn-qiankun/shared-utils";
import actions from "../../main-app/src/utils/globalState";

export {
  createUnauthorizedError,
  getApiErrorMessage,
  isUnauthorizedError,
  resolveApiErrorToastMessage,
  UNAUTHORIZED_ERROR_CODE,
} from "@eweadn-qiankun/shared-utils";

const instance = axios.create({
  baseURL: "/api",
  timeout: 10000,
});

function handleUnauthorized(message?: unknown): Promise<never> {
  const errorMessage = getApiErrorMessage(message, "登录已过期，请重新登录");
  console.error(errorMessage);

  if (typeof window !== "undefined") {
    showMessage({ message: errorMessage, type: "warning" });
    (window as Window & { openLoginModal?: () => void }).openLoginModal?.();
  }

  localStorage.removeItem("token");
  localStorage.removeItem("userInfo");
  actions.setGlobalState({ userInfo: null, token: null });

  return Promise.reject(createUnauthorizedError(errorMessage));
}

// 请求拦截器
instance.interceptors.request.use(
  (config: any) => {
    if (!config.headers) {
      config.headers = new AxiosHeaders(); // 使用 AxiosHeaders 构造函数初始化
    }
    config.headers["Xs-API-Key"] = "991F8829A1A5A085DB0A166D97F0F80B";
    // 添加认证头（示例）
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.token = token;
    }
    return config;
  },
  (error: AxiosError) => Promise.reject(error)
);

// 响应拦截器
instance.interceptors.response.use(
  (response: any) => {
    // 使用 HTTP 状态码判断请求是否成功
    if (response.status === 200) {
      // 适配后端返回格式: { success, message, data }
      const result = response.data;
      if (result && typeof result === "object" && "success" in result) {
        if (isUnauthorizedError(result)) {
          return handleUnauthorized(result.message);
        }
        // 如果是包装格式，返回 data 字段
        if (result.success) {
          return result.data;
        } else {
          // 业务失败
          return Promise.reject(result);
        }
      }
      // 兼容旧格式，直接返回
      return result;
    }
    // 非 200 状态码当作错误处理
    return Promise.reject(response.data || response.statusText);
  },
  (error: AxiosError) => {
    const data = error.response?.data;
    if (error.response?.status === 401 || isUnauthorizedError(data)) {
      return handleUnauthorized(
        data && typeof data === "object"
          ? (data as { message?: unknown }).message
          : undefined
      );
    }
    return Promise.reject(data || error.message);
  }
);
export default instance;
